// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: hidden;
  padding: 1%;
}
.app__main .app__top {
  position: relative;
  width: 100vw;
  height: 70vh;
}
.app__main .app__top .app_background {
  position: absolute;
  z-index: 0;
  opacity: 0.2;
  width: 100vw;
  height: 70vh;
  left: 0;
}
.app__main .app__top .app_top_content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: absolute;
  z-index: 1;
  width: 100%;
  left: 0;
}
.app__main .app__top .app_top_content .app_content_column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 68vh;
  width: 50%;
}
.app__main .app__top .app_top_content .app_content_column h2 {
  font-size: 3rem;
}
.app__main .app__top .app_top_content .app_content_column h2 span {
  color: #e63b11;
}
.app__main .app__top .app_top_content .app_content_column p {
  font-size: 2rem;
  width: 60%;
}
.app__main .app__top .app_top_content .app_content_column strong {
  margin: 2% 0 6% 0;
}
.app__main .app__top .app_top_content img {
  width: 18%;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .app__main .app__top {
    width: 99vw;
  }
  .app__main .app__top .app_background {
    width: 100%;
  }
  .app__main .app__top .app_top_content .app_content_column p {
    font-size: 1.5rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .app__main .app__top {
    height: 55vh;
  }
  .app__main .app__top .app_background {
    height: 55vh;
  }
  .app__main .app__top .app_top_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  .app__main .app__top .app_top_content .app_content_column h2 {
    font-size: 2.3rem;
  }
  .app__main .app__top .app_top_content .app_content_column p {
    font-size: 1.2rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .app__main .app__top {
    height: 65vh;
  }
  .app__main .app__top .app_background {
    height: 65vh;
  }
  .app__main .app__top .app_top_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  .app__main .app__top .app_top_content .app_content_column h2 {
    font-size: 2.3rem;
  }
  .app__main .app__top .app_top_content .app_content_column p {
    font-size: 1.2rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .app__main .app__top {
    height: 30vh;
  }
  .app__main .app__top .app_background {
    height: 30vh;
  }
  .app__main .app__top .app_top_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  .app__main .app__top .app_top_content .app_content_column {
    height: 55vh;
  }
  .app__main .app__top .app_top_content .app_content_column h2 {
    font-size: 2rem;
  }
  .app__main .app__top .app_top_content .app_content_column p {
    font-size: 0.9rem;
  }
  .app__main .app__top .app_top_content .app_content_column .column__row {
    width: 90%;
  }
  .app__main .app__top .app_top_content .app_content_column .column__row a img {
    width: 30%;
  }
}
@media (max-width: 690px) {
  .app__main .app__top {
    height: 50vh;
  }
  .app__main .app__top .app_background {
    height: 50vh;
  }
  .app__main .app__top .app_top_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;
    margin: 0 auto;
  }
  .app__main .app__top .app_top_content .app_content_column {
    margin: 0 auto;
  }
  .app__main .app__top .app_top_content .app_content_column h2 {
    font-size: 1.8rem;
  }
  .app__main .app__top .app_top_content .app_content_column p {
    font-size: 0.9rem;
    width: 100%;
  }
  .app__main .app__top .app_top_content .app_content_column strong {
    font-size: 0.9rem;
  }
  .app__main .app__top .app_top_content .app_content_column .column__row {
    width: 90%;
    margin: 1% auto;
    align-self: center;
  }
  .app__main .app__top .app_top_content .app_content_column .column__row a img {
    width: 90%;
  }
  .app__main .app__top .app_top_content #mobile__app {
    display: none;
  }
}
.app__main .app__how {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.app__main .app__how h2 {
  font-size: 3rem;
}
.app__main .app__how h2 span {
  color: #e63b11;
}
.app__main .app__how .app_how_content_top {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  margin: auto;
}
.app__main .app__how .app_how_content_top .content_side {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 20vh;
}
.app__main .app__how .app_how_content_top .content_side p {
  font-size: 1rem;
  width: 70%;
  position: relative;
}
.app__main .app__how .app_how_content_top .content_side p span {
  background-color: #e63b11;
  color: #fff;
  width: 2.2vw;
  height: 2.2vw;
  border-radius: 50%;
  font-weight: 800;
  font-size: 1.8rem;
  position: absolute;
  top: -10%;
  left: -20%;
  text-align: center;
}
.app__main .app__how .app_how_content_top img {
  width: 18%;
  margin-right: 8%;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .app__main .app__how .app_how_content_top .content_side p span {
    width: 3vw;
    height: 3vw;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .app__main .app__how h2 {
    font-size: 2.3rem;
  }
  .app__main .app__how .app_how_content_top .content_side p span {
    width: 3vw;
    height: 3vw;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .app__main .app__how h2 {
    font-size: 2.3rem;
  }
  .app__main .app__how .app_how_content_top .content_side p span {
    width: 3vw;
    height: 3vw;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .app__main .app__how h2 {
    font-size: 2rem;
  }
  .app__main .app__how .app_how_content_top .content_side p {
    font-size: 0.9rem;
  }
  .app__main .app__how .app_how_content_top .content_side p span {
    width: 4vw;
    height: 4vw;
    left: -25%;
  }
}
@media (max-width: 690px) {
  .app__main .app__how h2 {
    font-size: 1.8rem;
  }
  .app__main .app__how .app_how_content_top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .app__main .app__how .app_how_content_top .content_side p {
    font-size: 0.9rem;
  }
  .app__main .app__how .app_how_content_top .content_side p span {
    width: 8vw;
    height: 8vw;
    left: -25%;
    font-size: 1.5rem;
  }
  .app__main .app__how .app_how_content_top .content_side:nth-child(3) {
    margin-top: -15%;
  }
  .app__main .app__how .app_how_content_top img {
    width: 25%;
  }
}
.app__main .app__show {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
}
.app__main .app__show .app_show_row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 60%;
  margin: 1% auto;
}
.app__main .app__show .app_show_row:nth-child(even) {
  align-self: flex-end;
  flex-direction: row-reverse;
  margin-left: 30%;
}
.app__main .app__show .app_show_row .app_show_text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 43%;
  margin-left: 0;
}
.app__main .app__show .app_show_row .app_show_text h3 {
  color: #e63b11;
  font-size: 1.8rem;
  width: 70%;
}
.app__main .app__show .app_show_row .app_show_text p {
  font-size: 1.1rem;
  width: 70%;
}
.app__main .app__show .app_show_row img {
  width: 50%;
  margin-right: 10%;
}
@media (min-width: 691px) and (max-width: 850px) {
  .app__main .app__show .app_show_row {
    width: 70%;
  }
  .app__main .app__show .app_show_row .app_show_text {
    width: 60%;
  }
  .app__main .app__show .app_show_row .app_show_text h3 {
    font-size: 1.5rem;
    width: 90%;
  }
  .app__main .app__show .app_show_row .app_show_text p {
    font-size: 0.9rem;
    width: 100%;
  }
}
@media (max-width: 690px) {
  .app__main .app__show .app_show_row {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 99%;
    margin: 0 auto;
  }
  .app__main .app__show .app_show_row:nth-child(even) {
    flex-direction: column;
    align-items: flex-start;
    margin: auto auto auto 15%;
  }
  .app__main .app__show .app_show_row:nth-child(even) img {
    margin-left: 5%;
  }
  .app__main .app__show .app_show_row:nth-child(even) .app_show_text {
    margin-left: 0;
  }
  .app__main .app__show .app_show_row .app_show_text {
    width: 90vw;
    margin-left: 15vw;
  }
  .app__main .app__show .app_show_row .app_show_text h3 {
    font-size: 1.6rem;
  }
  .app__main .app__show .app_show_row .app_show_text p {
    font-size: 0.9rem;
  }
}
.app__main .app_show_apps {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 70vw;
  margin: 1% 0 2% 20%;
}
.app__main .app_show_apps a img {
  width: 50%;
}
@media (max-width: 690px) {
  .app__main .app_show_apps {
    margin: 2% 0 2% 10%;
  }
  .app__main .app_show_apps a img {
    width: 80%;
  }
}
@media (max-width: 690px) {
  .app__main {
    padding: 3%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/getApp.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EC8BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED/BA,kBAAA;EACA,WAAA;AAEJ;AAAI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AAER;AADQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;AAGZ;AADQ;ECkCJ,aAAA;EACA,mBAAA;EACA,6BAAA;EDlCQ,kBAAA;EACA,UAAA;EACA,WAAA;EACA,OAAA;AAKZ;AAJY;ECAR,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDDY,YAAA;EACA,UAAA;AAShB;AARgB;EACI,eAAA;AAUpB;AAToB;EACI,cC/Bf;AD0CT;AARgB;EACI,eAAA;EACA,UAAA;AAUpB;AARgB;EACI,iBAAA;AAUpB;AAPY;EACI,UAAA;AAShB;AANQ;EAxCJ;IAyCQ,WAAA;EASV;EARU;IACI,WAAA;EAUd;EANkB;IACI,iBAAA;EAQtB;AACF;AAJQ;EArDJ;IAsDQ,YAAA;EAOV;EANU;IACI,YAAA;EAQd;EANU;ICNR,aAAA;IACA,uBAAA;IACA,6BAAA;EDeF;EARkB;IACI,iBAAA;EAUtB;EARkB;IACI,iBAAA;EAUtB;AACF;AANQ;EAtEJ;IAuEQ,YAAA;EASV;EARU;IACI,YAAA;EAUd;EARU;ICvBR,aAAA;IACA,uBAAA;IACA,6BAAA;EDkCF;EAVkB;IACI,iBAAA;EAYtB;EAVkB;IACI,iBAAA;EAYtB;AACF;AARQ;EAvFJ;IAwFQ,YAAA;EAWV;EAVU;IACI,YAAA;EAYd;EAVU;ICxCR,aAAA;IACA,uBAAA;IACA,6BAAA;EDqDF;EAbc;IACI,YAAA;EAelB;EAdkB;IACI,eAAA;EAgBtB;EAdkB;IACI,iBAAA;EAgBtB;EAdkB;IACI,UAAA;EAgBtB;EAd0B;IACI,UAAA;EAgB9B;AACF;AAVQ;EAjHJ;IAkHQ,YAAA;EAaV;EAZU;IACI,YAAA;EAcd;EAZU;ICtFR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IDqFY,UAAA;IACA,cAAA;EAiBd;EAhBc;IACI,cAAA;EAkBlB;EAjBkB;IACI,iBAAA;EAmBtB;EAjBkB;IACI,iBAAA;IACA,WAAA;EAmBtB;EAjBkB;IACI,iBAAA;EAmBtB;EAjBkB;IACI,UAAA;IACA,eAAA;IACA,kBAAA;EAmBtB;EAjB0B;IACI,UAAA;EAmB9B;EAdc;IACI,aAAA;EAgBlB;AACF;AAZI;EC9HA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AD6IJ;AAhBQ;EACI,eAAA;AAkBZ;AAjBY;EACI,cClKP;ADqLT;AAhBQ;ECzFJ,aAAA;EACA,mBAAA;EACA,uBAAA;EDyFQ,UAAA;EACA,YAAA;AAoBZ;AAnBY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AAqBhB;AApBgB;EACI,eAAA;EACA,UAAA;EACA,kBAAA;AAsBpB;AArBoB;EACI,yBCpLf;EDqLe,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAuBxB;AAnBY;EACI,UAAA;EACA,gBAAA;AAqBhB;AAlBQ;EAIgB;IACI,UAAA;IACA,WAAA;EAiB1B;AACF;AAZQ;EACI;IACI,iBAAA;EAcd;EATsB;IACI,UAAA;IACA,WAAA;EAW1B;AACF;AANQ;EACI;IACI,iBAAA;EAQd;EAHsB;IACI,UAAA;IACA,WAAA;EAK1B;AACF;AAAQ;EACI;IACI,eAAA;EAEd;EAEkB;IACI,iBAAA;EAAtB;EACsB;IACI,UAAA;IACA,WAAA;IACA,UAAA;EAC1B;AACF;AAKQ;EACI;IACI,iBAAA;EAHd;EAKU;ICjOR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;ED+NF;EAEkB;IACI,iBAAA;EAAtB;EACsB;IACI,UAAA;IACA,WAAA;IACA,UAAA;IACA,iBAAA;EAC1B;EAEkB;IACI,gBAAA;EAAtB;EAGc;IACI,UAAA;EADlB;AACF;AAKI;ECvPA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EDsPI,yBAAA;AAAR;AACQ;EC5OJ,aAAA;EACA,mBAAA;EACA,6BAAA;ED4OQ,UAAA;EACA,eAAA;AAGZ;AAFY;EACI,oBAAA;EACA,2BAAA;EACA,gBAAA;AAIhB;AAFY;ECjRR,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EDgRY,UAAA;EACA,cAAA;AAOhB;AANgB;EACI,cC9SX;ED+SW,iBAAA;EACA,UAAA;AAQpB;AANgB;EACI,iBAAA;EACA,UAAA;AAQpB;AALY;EACI,UAAA;EACA,iBAAA;AAOhB;AAJQ;EACI;IACI,UAAA;EAMd;EALc;IACI,UAAA;EAOlB;EANkB;IACI,iBAAA;IACA,UAAA;EAQtB;EANkB;IACI,iBAAA;IACA,WAAA;EAQtB;AACF;AAJQ;EACI;ICvSR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IDsSY,UAAA;IACA,cAAA;EASd;EARc;IACI,sBAAA;IACA,uBAAA;IACA,0BAAA;EAUlB;EATkB;IACI,eAAA;EAWtB;EATkB;IACI,cAAA;EAWtB;EARc;IACI,WAAA;IACA,iBAAA;EAUlB;EATkB;IACI,iBAAA;EAWtB;EATkB;IACI,iBAAA;EAWtB;AACF;AANI;ECrTA,aAAA;EACA,mBAAA;EACA,6BAAA;EDqTI,WAAA;EACA,mBAAA;AAUR;AARY;EACI,UAAA;AAUhB;AAPQ;EATJ;IAUQ,mBAAA;EAUV;EARc;IACI,UAAA;EAUlB;AACF;AANI;EA1XJ;IA2XQ,WAAA;EASN;AACF","sourcesContent":["@import './variables.scss';\n\n.app__main{\n    @include columnStartCenter;\n    overflow-y: hidden;\n    padding: 1%;\n\n    .app__top{\n        position: relative;\n        width: 100vw;\n        height: 70vh;\n        .app_background{\n            position: absolute;\n            z-index: 0;\n            opacity: 0.2;\n            width: 100vw;\n            height: 70vh;\n            left: 0;\n        }\n        .app_top_content{\n            @include rowEven;\n            position: absolute;\n            z-index: 1;\n            width: 100%;\n            left: 0;\n            .app_content_column{\n                @include columnStart;\n                height: 68vh;\n                width: 50%;\n                h2{\n                    font-size: 3rem;\n                    span{\n                        color: $orange;\n                    }\n                }\n                p{\n                    font-size: 2rem;\n                    width: 60%;\n                }\n                strong{\n                    margin: 2% 0 6% 0;\n                }\n            }\n            img{\n                width: 18%;\n            }\n        }\n        @media (min-width: $smallScreen) and (max-width: 1900px){\n            width: 99vw;\n            .app_background{\n                width: 100%;\n            }\n            .app_top_content{\n                .app_content_column{\n                    p{\n                        font-size: 1.5rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n            height: 55vh;\n            .app_background{\n                height: 55vh;\n            }\n            .app_top_content{\n                @include rowEvenStart;\n                .app_content_column{\n                    h2{\n                        font-size: 2.3rem;\n                    }\n                    p{\n                        font-size: 1.2rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n            height: 65vh;\n            .app_background{\n                height: 65vh;\n            }\n            .app_top_content{\n                @include rowEvenStart;\n                .app_content_column{\n                    h2{\n                        font-size: 2.3rem;\n                    }\n                    p{\n                        font-size: 1.2rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            height: 30vh;\n            .app_background{\n                height: 30vh;\n            }\n            .app_top_content{\n                @include rowEvenStart;\n                .app_content_column{\n                    height: 55vh;\n                    h2{\n                        font-size: 2rem;\n                    }\n                    p{\n                        font-size: .9rem;\n                    }\n                    .column__row{\n                        width: 90%;\n                        a{\n                            img{\n                                width: 30%;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        @media(max-width: $mobile){\n            height: 50vh;\n            .app_background{\n                height: 50vh;\n            }\n            .app_top_content{\n                @include columnStack;\n                width: 90%;\n                margin: 0 auto;\n                .app_content_column{\n                    margin: 0 auto;\n                    h2{\n                        font-size: 1.8rem;\n                    }\n                    p{\n                        font-size: .9rem;\n                        width: 100%;\n                    }\n                    strong{\n                        font-size: .9rem;\n                    }\n                    .column__row{\n                        width: 90%;\n                        margin: 1% auto;\n                        align-self: center;\n                        a{\n                            img{\n                                width: 90%;\n                            }\n                        }\n                    }\n                }\n                #mobile__app{\n                    display: none;\n                }\n            }\n        }\n    }\n    .app__how{\n        @include columnStartCenter;\n        h2{\n            font-size: 3rem;\n            span{\n                color: $orange;\n            }\n        }\n        .app_how_content_top{\n            @include rowCenter;\n            width: 70%;\n            margin: auto;\n            .content_side{\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: space-around;\n                height: 20vh;\n                p{\n                    font-size: 1rem;\n                    width:70%;\n                    position: relative;\n                    span{\n                        background-color: $orange;\n                        color: #fff;\n                        width: 2.2vw;\n                        height: 2.2vw;\n                        border-radius: 50%;\n                        font-weight: 800;\n                        font-size: 1.8rem;\n                        position: absolute;\n                        top: -10%;\n                        left: -20%;\n                        text-align: center;\n                    }\n                }\n            }\n            img{\n                width: 18%;\n                margin-right: 8%;\n            }\n        }\n        @media (min-width: $smallScreen) and (max-width: 1900px){\n            .app_how_content_top{\n                .content_side{\n                    p{\n                        span{\n                            width: 3vw;\n                            height: 3vw;\n                        }    \n                    }\n                }\n            }\n        }\n        @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n            h2{\n                font-size: 2.3rem;\n            }\n            .app_how_content_top{\n                .content_side{\n                    p{\n                        span{\n                            width: 3vw;\n                            height: 3vw;\n                        }    \n                    }\n                }\n            }\n        }\n        @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n            h2{\n                font-size: 2.3rem;\n            }\n            .app_how_content_top{\n                .content_side{\n                    p{\n                        span{\n                            width: 3vw;\n                            height: 3vw;\n                        }    \n                    }\n                }\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            h2{\n                font-size: 2rem;\n            }\n            .app_how_content_top{\n                .content_side{\n                    p{\n                        font-size: .9rem;\n                        span{\n                            width: 4vw;\n                            height: 4vw;\n                            left: -25%;\n                        }    \n                    }\n                }\n            }\n\n        }\n        @media(max-width: $mobile){\n            h2{\n                font-size: 1.8rem;\n            }\n            .app_how_content_top{\n                @include columnStack;\n                .content_side{\n                    p{\n                        font-size: .9rem;\n                        span{\n                            width: 8vw;\n                            height: 8vw;\n                            left: -25%;\n                            font-size: 1.5rem;\n                        }    \n                    }\n                    &:nth-child(3){\n                        margin-top: -15%;\n                    }\n                }\n                img{\n                    width: 25%;\n                }\n            }\n        }\n    }\n    .app__show{\n        @include columnStack;\n        background-color: #f2f2f2;\n        .app_show_row{\n            @include rowEven;\n            width: 60%;\n            margin: 1% auto;\n            &:nth-child(even){\n                align-self: flex-end;\n                flex-direction: row-reverse;\n                margin-left: 30%;\n            }\n            .app_show_text{\n                @include columnStart;\n                width: 43%;\n                margin-left: 0;\n                h3{\n                    color: $orange;\n                    font-size: 1.8rem;\n                    width: 70%;\n                }\n                p{\n                    font-size: 1.1rem;\n                    width: 70%;\n                }\n            }\n            img{\n                width: 50%;\n                margin-right: 10%;\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            .app_show_row{\n                width: 70%;\n                .app_show_text{\n                    width: 60%;\n                    h3{\n                        font-size: 1.5rem;\n                        width: 90%;\n                    }\n                    p{\n                        font-size: .9rem;\n                        width: 100%;\n                    }\n                }\n            }\n        }\n        @media (max-width: $mobile){\n            .app_show_row{\n                @include columnStack;\n                width: 99%;\n                margin: 0 auto;\n                &:nth-child(even){\n                    flex-direction: column;\n                    align-items: flex-start;\n                    margin: auto auto auto 15%;\n                    img{\n                        margin-left: 5%;\n                    }\n                    .app_show_text{\n                        margin-left: 0;\n                    }\n                }\n                .app_show_text{\n                    width: 90vw;\n                    margin-left: 15vw;\n                    h3{\n                        font-size: 1.6rem;\n                    }\n                    p{\n                        font-size: .9rem;\n                    }\n                }\n            }\n        }\n    }\n    .app_show_apps{\n        @include rowEven;\n        width: 70vw;\n        margin: 1% 0 2% 20%;\n        a{\n            img{\n                width: 50%;\n            }         \n        }\n        @media(max-width: $mobile){\n            margin: 2% 0 2% 10%;\n            a{\n                img{\n                    width: 80%;\n                }\n            }\n        }\n    }\n    @media(max-width: $mobile){\n        padding: 3%;\n    }\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
